import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '../../../../core/field-definitions/entities/field-definition.entity';
import { MultiFormSelectOptions } from '../../../entities/multi-form-select-options.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormListComplexBaseComponent } from '../base-complex/form-list-complex-base.component';
import { ShFormListBaseComponent } from '../base-simple/form-list-base.component';

type SanitizeToStringFunction = (value: string, existingValues: string[]) => string;
type SanitizeToStringArrayFunction = (value: string, existingValues: string[]) => string[];

@Component({
    selector: 'sh-form-list',
    templateUrl: './form-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ShFormGroupComponent,
    ShFormListComplexBaseComponent,
    ReactiveFormsModule,
    ShFormListBaseComponent,
    AsyncPipe
]
})
export class ShFormListComponent extends ShBaseFormComponent {
    @Input() autocompleteFct?: (term: string) => Observable<MultiFormSelectOptions>;
    @Input() placeholderMsg?: string;
    @Input() duplicateErrorMsg!: string;
    @Input() fieldType: FieldType = FieldType.SimpleField;

    // Number specific
    @Input() min: number = Number.MIN_SAFE_INTEGER;
    @Input() max: number = Number.MAX_SAFE_INTEGER;
    @Input() step = 1;

    @Input() sanitizeFct: SanitizeToStringFunction | SanitizeToStringArrayFunction = (value: string) => value;
}
